import * as React from "react";
import { forwardRef } from "react";
const SvgOracle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 32 20", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "#C74634", strokeWidth: 4, d: "m10,2a8,8 0 1,0 0,16h12a8,8 0 1,0 0-16z" }));
const ForwardRef = forwardRef(SvgOracle);
export default ForwardRef;
